var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{key:_vm.index,staticClass:"hint",class:{ pulse: _vm.hasHint },attrs:{"src":_vm.hintSrc},on:{"click":_vm.showHint}})}
var staticRenderFns = []

export { render, staticRenderFns }